import React, { useEffect, useState } from "react";
import { mdiMenu } from "@mdi/js";

import {
  Box,
  Button,
  FlexRow,
  FlexCol,
  Logo,
  Text,
  Icon,
  Panel
} from "src/components";
import { Link } from "gatsby";

function Header({ location }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isUnmounting, setUnmounting] = useState(false);

  function closeMenu() {
    setUnmounting(true);
    setTimeout(() => {
      setUnmounting(false);
      setIsOpen(false);
    }, 333);
  }

  useEffect(() => {
    if (isOpen) {
      closeMenu();
    }
  }, [location]);

  return (
    <>
      <div
        css={`
          height: 96px;
          @media (max-width: 40em) {
            height: 72px;
          }
        `}
      />
      <header
        css={`
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          height: 96px;
          z-index: 1000;
          padding: 0 7.5vw;
          background-color: ${props => props.theme.colors.bg.default};
          @media (max-width: 40em) {
            height: 72px;
          }
        `}
      >
        <div
          css={`
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            max-width: 80rem;
            margin: 0 auto;
            padding: 24px 0;
          `}
        >
          <Link
            to="/"
            css={`
              height: 24px;
              @media (min-width: 40em) {
                height: 32px;
              }
            `}
          >
            <Logo
              style={{ width: "auto", height: "100%", verticalAlign: "top" }}
            />
          </Link>
          <FlexRow
            justifyContent="flex-end"
            alignItems="center"
            flex={1}
            height="100%"
          >
            <Box
              css={`
                display: none;
                @media (max-width: 72em) {
                  display: flex;
                }
              `}
            >
              <Box color="text.default">
                <Icon
                  path={mdiMenu}
                  size={1.5}
                  color="currentColor"
                  onClick={() => {
                    setIsOpen(true);
                  }}
                  style={{ verticalAlign: "top", cursor: "pointer" }}
                />
              </Box>
              <Panel
                mounted={isOpen}
                unmounting={isUnmounting}
                close={() => {
                  closeMenu();
                }}
              >
                <FlexCol
                  pt="72px"
                  minHeight="100%"
                  justifyContent="space-between"
                >
                  <Box px={4}>
                    <Text
                      mb={3}
                      fontWeight={600}
                      fontSize={3}
                      color="brand.blue"
                    >
                      <Link children={`Home`} to="/" />
                    </Text>
                    <Text
                      mb={3}
                      fontWeight={600}
                      fontSize={3}
                      color="brand.blue"
                    >
                      <Link
                        children={`Your Questions Answered`}
                        to="/questions-answered"
                      />
                    </Text>
                    <Text
                      mb={3}
                      fontWeight={600}
                      fontSize={3}
                      color="brand.blue"
                    >
                      <Link children={`Abrio News`} to="/news" />
                    </Text>
                    <Text
                      mb={3}
                      fontWeight={600}
                      fontSize={3}
                      color="brand.blue"
                    >
                      <Link children={`Mayor's Blog`} to="/mayors-blog" />
                    </Text>
                    <Text
                      mb={4}
                      fontWeight={600}
                      fontSize={3}
                      color="brand.blue"
                    >
                      <Link children={`Contact us`} to="/contact" />
                    </Text>
                  </Box>
                  <Button
                    style={{
                      marginTop: "auto",
                      paddingTop: 24,
                      paddingBottom: 24
                    }}
                    width={1}
                    children={`Register`}
                    as={Link}
                    to="/register"
                    variant="primary"
                  />
                </FlexCol>
              </Panel>
            </Box>
            <FlexRow
              css={`
                display: flex;
                @media (max-width: 72em) {
                  display: none;
                }
              `}
              alignItems="center"
            >
              <Text mr="32px" fontWeight={600} color="brand.blue">
                <Link
                  children={`Your Questions Answered`}
                  to="/questions-answered"
                  activeStyle={{ color: "#6D3A5D" }}
                />
              </Text>
              <Text mr="32px" fontWeight={600} color="brand.blue">
                <Link
                  children={`Abrio News`}
                  to="/news"
                  activeStyle={{ color: "#6D3A5D" }}
                />
              </Text>
              <Text mr="32px" fontWeight={600} color="brand.blue">
                <Link
                  children={`Mayor's Blog`}
                  to="/mayors-blog"
                  activeStyle={{ color: "#6D3A5D" }}
                />
              </Text>
              <Text mr="24px" fontWeight={600} color="brand.blue">
                <Link
                  children={`Contact us`}
                  to="/contact"
                  activeStyle={{ color: "#6D3A5D" }}
                />
              </Text>
              <Button
                children={`Register`}
                as={Link}
                to="/register"
                variant="primaryAlt"
              />
            </FlexRow>
          </FlexRow>
        </div>
      </header>
    </>
  );
}

export default Header;
